/**
 * Meta (Facebook) Pixel helpers.
 *
 * The base pixel snippet (init + initial PageView + fbevents.js loader) lives
 * directly in `index.html`'s <head> so it runs on every document load — and,
 * per the site owner's explicit instruction, it is NOT consent-gated (unlike
 * GA in `analytics.ts`). These helpers fire subsequent SPA page views and
 * standard conversion events. The pixel ID and event names must never change.
 */

declare global {
  interface Window {
    fbq?: (...args: unknown[]) => void;
  }
}

/** Fire a standard Meta Pixel event. No-op if the pixel hasn't loaded yet. */
export function fbqTrack(event: string, params?: Record<string, unknown>): void {
  try {
    if (typeof window !== 'undefined' && typeof window.fbq === 'function') {
      window.fbq('track', event, params ?? {});
    }
  } catch {
    /* analytics must never break the page */
  }
}

export {};
